import { Autocomplete, Button, InputLabel, Stack, TextField } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import { userService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { DbSearchAdvancedQueryInfos } from "../../../Core/Api/Types/db-search-advanced-query-infos";
import { DbUserBasicInfos } from "../../../Core/Api/Types/db-user-basic-infos";
import { useTranslation } from "react-i18next";

export type ModalSendQueryElementProps = {
  query: DbSearchAdvancedQueryInfos;
};

export type ModalSendQueryProps = CommonModalProps<ModalSendQueryElementProps>;

const ModalSendQuery = React.forwardRef<any, ModalSendQueryProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, ...modalProps } = props;
  const enqueueSnackbar = useCustomSnackbar();
  const { query } = modalProps;

  const [usersList, SetUsersList] = React.useState<DbUserBasicInfos[]>([]);
  const [selectedUsers, setSelectedUsers] = React.useState<DbUserBasicInfos[]>(
    usersList.filter((x) => query.sharedWithUserIds?.includes(x.id))
  );
  const [userFilter, setUserFilter] = React.useState<string>("");

  function areArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;

    return arr1.every((element) => arr2.includes(element));
  }

  const handleConfirmClick = () => {
    let request: DbSearchAdvancedQueryInfos = query;
    request.sharedWithUserIds = selectedUsers.map((x) => x.id);

    userService.PutSearchQueries(request).then((response) => {
      if (response.success) enqueueSnackbar(t("alert:success.queryIsShared"), "success");
    });

    closeModal();
  };

  const handleCancelClick = () => {
    closeModal();
  };

  React.useEffect(() => {
    userService.GetAllUsersBasic().then(function (response) {
      if (response.users) {
        SetUsersList(response.users);
        setSelectedUsers(response.users.filter((x) => query.sharedWithUserIds?.includes(x.id)));
      }
    });
  }, []);

  return (
    <Modal
      title={t("common:sendQuery")}
      reference={ref}
      closeModal={handleCancelClick}
      width={600}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button
            color="success"
            variant="outlined"
            onClick={handleConfirmClick}
            disabled={areArraysEqual(
              query.sharedWithUserIds,
              selectedUsers.map((x) => x.id)
            )}
          >
            {t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={1}>
        <InputLabel>{t("common:sendQuery")}</InputLabel>
        <Autocomplete
          options={usersList.filter((x) =>
            (x.firstName?.toLowerCase() + " " + x.lastName?.toLowerCase()).includes(userFilter)
          )}
          multiple={true}
          onInputChange={(e, value) => {
            setUserFilter(value.toLowerCase());
          }}
          value={selectedUsers || null}
          onChange={(e, v: DbUserBasicInfos[]) => {
            setSelectedUsers(v);
          }}
          getOptionLabel={(value: any) => value.firstName + " " + value.lastName}
          renderInput={(params) => (
            <TextField sx={{ mt: -2, mb: 2 }} {...params} placeholder={t("field:placeholder.shareWith")} />
          )}
        />
      </Stack>
    </Modal>
  );
});

export default ModalSendQuery;
